<template>
  <div class="logo-container">
    <router-link to="/" class="logo-link">
      <img class="logo" src="@/assets/images/logo/logo.svg" alt="logo" />
    </router-link>
  </div>
</template>
